export const BESTSELLERS_PRICE_LIST_TITLE = 'Bestsellers';
export const HEADER_LABEL = 'Products';
export const HEADER_PRICE_LABEL = 'Price';
